import { useEffect, useState } from 'react';
import { ManifestApiModel } from '~/lib/api/smartsend/types';
import { SettingsCache } from '~/lib/consts/settings-cache';
import { useServiceLogo } from '../../../../hooks/use-service-logo';
import { ManifestCanBeCompleted } from './ManifestCanBeCompleted';
import { UpdateManifestCache } from '../../lib/cache/UpdateManifestCache';
import { P2GBox, P2GText, P2GLink, P2GImage } from '@parcel2go/core-ui';
import { useSmartSendApi } from '~/lib/api/smartsend/use-smartsend-api';
import useGoto from '../../../../hooks/use-goto';
import { RoutingConstants } from '../../lib/consts/RoutingConstants';
import AlertWithIcon from '../AlertWithIcon';

interface ManifestModel extends ManifestApiModel {
  Provider: string;
}

export default function ManifestReminder() {
  const { goTo } = useGoto();
  const { getManifests, getQuoteProviders } = useSmartSendApi();
  const [draftManifests, setDraftManifests] = useState<ManifestModel[]>([]);
  const { getSrc } = useServiceLogo();

  const getOutstanding = async () => {
    let output: ManifestModel[] = [];
    if (SettingsCache.settings.Features.includes('Manifests')) {
      const providers = await getQuoteProviders();
      if (providers.success) {
        const options = providers.result.Providers.filter((x) => x.Manifestable && x.Accounts.length > 0);
        if (options.length > 0) {
          const providerId = options[0].Id;
          const accountId = options[0].Accounts[0].Id;
          const ms = await getManifests(providerId, accountId);
          if (ms.success) {
            UpdateManifestCache(providerId, accountId, ms.result.Manifests);
            output = ms.result.Manifests.filter(ManifestCanBeCompleted).map((x) => {
              return { ...x, Provider: providerId };
            });
          }
        }
      }
    }
    return output;
  };

  useEffect(() => {
    const run = async () => {
      const res = await getOutstanding();
      setDraftManifests(res);
    };
    run();
    // const interval = setInterval(getOutstanding, 2 * 60000);
    // return () => clearInterval(interval);
  }, []);

  if (!draftManifests || draftManifests.length == 0) {
    return null;
  }

  return (
    <P2GBox pb={2}>
      <AlertWithIcon
        icon={
          <P2GImage
            src={getSrc({ Provider: draftManifests[0]?.Provider, Id: null }) || ''}
            alt={`Manifests`}
            style={{ height: '20px' }}
          />
        }
      >
        <P2GText variant="body2">
          If you have processed your orders for the day and are ready to review and complete the Royal Mail end-of-day
          process <P2GLink onClick={() => goTo(RoutingConstants.Manifests)}>Click Here</P2GLink>.
        </P2GText>
      </AlertWithIcon>
    </P2GBox>
  );
}
